// Questionnaire definitions live in questionnaires.json so that the Pages
// Functions (via scripts/questionnaire-settings.mjs) read the same source.
// Published id/version pairs must never change: stored responses reference them.
import type { QuestionnaireDefinition } from "@/domain/questionnaire";
import definitions from "./questionnaires.json";

export const QUESTIONNAIRES = definitions as QuestionnaireDefinition[];
